module.exports = __webpack_public_path__ + "img/cert-product.57808e1.webp";